var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeople24 = function SvgPeople24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.507 7.391a4.343 4.343 0 1 1 8.687 0 4.343 4.343 0 0 1-8.687 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.355 11.026a3.472 3.472 0 0 1-1.94-.589 6.314 6.314 0 0 0 .779-3.046 6.317 6.317 0 0 0-.664-2.828 3.489 3.489 0 1 1 1.825 6.463ZM14.123 13.165a7.56 7.56 0 0 1 3.533 5.594h2.522c.847 0 1.533-.686 1.533-1.533a4.2 4.2 0 0 0-4.2-4.2H15.2c-.372 0-.733.048-1.077.139Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.143 13.048A6.143 6.143 0 0 0 2 19.19c0 1.025.831 1.857 1.857 1.857h10.286A1.857 1.857 0 0 0 16 19.19a6.143 6.143 0 0 0-6.143-6.143H8.143Z",
    fill: "currentColor"
  })));
};
export default SvgPeople24;